import { WebPageDetails } from '@/services/analytics/platforms/adobe-analytics/models';
import { GroupOrderPageLoadEvent } from '@/services/analytics/events';
import { AdobePageLoadEvent } from './adobe-page-load';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { ServicesContainer } from '@/services';

export class AdobeGroupOrderPageLoadEvent extends AdobePageLoadEvent {
  constructor(event: GroupOrderPageLoadEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);
    Object.assign(this.web.webPageDetails, this.createGroupOrderDetails(event.eventType ?? ''));

    if (event.eventType == 'cancel') {
      this.web.webPageDetails.subPageName = 'cancel';
      this.web.webPageDetails.subPageViews = { value: 1 };
    } else {
      this.web.webPageDetails.page = 'create';
      this.web.webPageDetails.pageViews = { value: 1 };
    }
  }

  createGroupOrderDetails(eventType: string): WebPageDetails {
    let details = {
      pageType: 'group-order',
      siteSection: 'order',
      subSection1: 'group-order',
      name: `order:group-order:${eventType ? eventType : 'create'}`,
    } as WebPageDetails;

    return details;
  }
}
